/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import {
  Route, useHistory, useLocation
} from 'react-router-dom'

import BlankLayout from 'Layouts/blank'
import { useAuth } from '../../../Hooks'

function CustomRoute({
  component: Component, layout: Layout = BlankLayout, ...rest
}) {
  return (
    <>
      <Route
        {...rest}
        render={(props) => (
          <Layout>
            <Component {...props} {...rest} />
          </Layout>
        )}
      />
    </>
  )
}

export default CustomRoute
